import { useMutation, useQuery } from "@apollo/react-hooks";
import { Button, Checkbox, Col, Form, message, Row, Typography } from "antd";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import NotificationImage from "../../../../Assets/Images/003.jpg";
import {
  UPDATE_USER_LAST_SCREEN,
  UPDATE_USER_NOTIFICATION,
} from "../../../../Graphql/mutations";
import { GET_LAST_SCREEN } from "../../../../Graphql/queries";

const { Title } = Typography;

export const NotificationSetupPage = () => {
  const user_id = localStorage.getItem("user_id");
  const history = useHistory();
  const { data } = useQuery(GET_LAST_SCREEN, {
    variables: { user_id },
    fetchPolicy: "cache-and-network",
  });

  const [UPDATE_USER_LAST_SCREEN_MUTATION] = useMutation(
    UPDATE_USER_LAST_SCREEN
  );

  const [UPDATE_USER_NOTIFICATION_MUTATION, { loading }] = useMutation(
    UPDATE_USER_NOTIFICATION
  );

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  const tailLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  useEffect(() => {
    if (data && data?.getUsersById?.last_screen !== history.location.pathname) {
      UPDATE_USER_LAST_SCREEN_MUTATION({
        variables: {
          user_id,
          last_screen: history.location.pathname,
        },
      });
    }
  }, [data]);

  const onContinue = async (values) => {
    try {
      const response = await UPDATE_USER_NOTIFICATION_MUTATION({
        variables: {
          user_id,
          phone_notifications: values.options.includes("text"),
          email_notifications: values.options.includes("email"),
        },
      });
      if (!response.errors) {
        history.push("/on-boarding/shift-management");
      }
    } catch (err) {
      message.error("Must select one");
    }
  };

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={NotificationImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight">
        <div className="notificationSetup">
          <Title level={2}>Notification Setup</Title>
          <p className="subTitle">
            Setup how you would like to receive notifications for all your tasks
          </p>
          <Form {...layout} onFinish={onContinue}>
            <Form.Item
              name="options"
              rules={[
                {
                  required: true,
                  message: "Must select one",
                },
              ]}
            >
              <Checkbox.Group style={{ width: "100%" }}>
                <Row>
                  <Col span={24}>
                    <Checkbox value="text">
                      <label htmlFor="">Text Message</label>
                      <span className="subCont">
                        You will be receiving daily reminders for your assigned
                        tasks on your registered number
                        {/* <strong>{userData?.user_by_pk.phone}</strong> */}
                      </span>
                    </Checkbox>
                  </Col>
                </Row>
              </Checkbox.Group>
            </Form.Item>
            <Form.Item {...tailLayout} className="buttonSec pt-5">
              <Button
                type="primary"
                size="large"
                shape="round"
                htmlType="submit"
                loading={loading}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
